const urlBase = process.env.REACT_APP_URL_BASE;

const endpoints = {
    TRACKING_ORDER_BY_ID: 'https://api-rastreio.ciahering.com.br/ObjetoRastreio/TrackingOrderById/:trackingNumber'
}

export default endpoints;